import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const removeUtilityAPI = async (id, t, successText) => {
  await axios({
    url: `/api/v2/admin-utility/utility/delete`,
    method: "DELETE",
    data: {
      id
    }
  });
  successHandling(t, successText);
  return true;
};
